import gql from 'graphql-tag'

export const GetProductsQuery = gql`
  query getProducts(
    $contentTile: String
    $series: String
    $collection: String
    $gender: String
    $category: String
    $sport: String
    $season: String
    $fitStyle: String
    $limit: Int
    $order: String
    $offset: Int
    $searchText: String
    $onlyActive: Boolean
    $isAdminIntake: Boolean
    $excludeDesigns: Boolean
    $fromCatalog: Boolean
    $onlyEvo: Boolean
    $fromPreview: Boolean
  ) {
    products(
      contentTile: $contentTile
      series: $series
      collection: $collection
      gender: $gender
      category: $category
      sport: $sport
      season: $season
      fitStyle: $fitStyle
      limit: $limit
      order: $order
      offset: $offset
      text: $searchText
      onlyActive: $onlyActive
      isAdminIntake: $isAdminIntake
      excludeDesigns: $excludeDesigns
      fromCatalog: $fromCatalog
      onlyEvo: $onlyEvo
      fromPreview: $fromPreview
    ) {
      fullCount
      products {
        id
        code
        yotpoId: yotpo_id
        name
        onlyProDesign: only_pro_design
        active
        type: name
        description: short_description
        isTopProduct
        comingSoon: coming_soon
        customizable: design_center
        retailMen: men_retail
        retailWomen: women_retail
        vinylMaterials: vinyl_materials
        category_id
        categoryName: category_name
        fitStyles {
          id
          name: description
          info
        }
        genders {
          id
          name: gender
        }
        priceRange {
          quantity
          price
          abbreviation
          shortName: short_name
        }
        images: pictures2 {
          front: front_image
          genderId: gender_id
          color_id
          thumbnail
          thumbnailAlt: thumbnail_alt
        }
        colors {
          id
          name
          image
        }
        serie
      }
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        countryName: country_name
        countryCode: country_code
      }
      reseller {
        id
        status
        currency
        comission
        inline
        paypalAccount: paypal_account
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductCatalogueThumbnailsListV2/data.ts